import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { WeatherProvider } from './context/WeatherContext';
import Footer from './components/Footer';
import NavMenu from './components/NavMenu';
import SiteFixedUI from './components/SiteFixedUI';
import ScrollToTop from './components/ScrollToTop';
import About from './pages/About';
import Contact from './pages/Contact';
import Home from './pages/Home';
import Projects from './pages/Projects';
import Resume from './pages/Resume';
import PageNotFound from './pages/PageNotFound';
import FaviconSync from './components/FaviconSync';
import Games from './pages/Games';
import DinoGame from './pages/DinoGame';
import TwentyFortyEight from './pages/TwentyFortyEight';
import SnakeGame from './pages/SnakeGame';
import SpaceInvaders from './pages/SpaceInvaders';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import './App.css';

const routes = [
  { path: "/about", component: About },
  { path: "/contact", component: Contact },
  { path: "/resume", component: Resume },
  { path: "/projects", component: Projects },
  { path: "/blog/:slug", component: BlogPost },
  { path: "/blog", component: Blog, exact: true },
  { path: "/", component: Home, exact: true },
  { path: "/games/dino", component: DinoGame },
  { path: "/games/snake", component: SnakeGame },
  { path: "/games/space-invaders", component: SpaceInvaders },
  { path: "/games/2048", component: TwentyFortyEight },
  { path: "/games", component: Games },
];

export default function App() {
  return (
    <WeatherProvider>
      <>
        <FaviconSync />
        <Router>
          <NavMenu />
          <SiteFixedUI />
          <ScrollToTop />
          <main>
            <Switch>
              {routes.map(({ path, component, exact = false }) => (
                <Route key={path} path={path} component={component} exact={exact} />
              ))}
              <Route component={PageNotFound} /> {/* 404 Route placed last */}
            </Switch>
          </main>
          <Footer />
        </Router>
      </>
    </WeatherProvider>
  );
}
